// @module Tavanoteam.HazardousProducts.HazardousProducts
define('Tavanoteam.HazardousProducts.HazardousProducts.View'
	, [
		'tavanoteam_hazardousproducts_hazardousproducts.tpl'

		, 'Backbone'
	]
	, function (
		tavanoteam_hazardousproducts_hazardousproducts_tpl

		, Backbone
	) {
		'use strict';

		// @class Tavanoteam.HazardousProducts.HazardousProducts.View @extends Backbone.View
		return Backbone.View.extend({

			template: tavanoteam_hazardousproducts_hazardousproducts_tpl

			, initialize: function (options) {
				this.container = options.container;
				this.pdpComponent = this.container.getComponent('PDP');
				this.cart = this.container.getComponent('Cart');
				this.item = this.pdpComponent.getItemInfo().item;
			}

			, getContext: function getContext() {
				var isHazardous = this.item.custitemcustitem_is_hazardous;

				return {
					isHazardous: isHazardous
				};
			}
		});
	});
